export const materials = "/declarations"
export const materialDetails = ":contractNumber/:materialNumber"
export const declarationCreation = "declaration-creation"
export const selectionOfDeclarationTypeForm = "selection-of-declaration-type"
export const selectionOfMaterialForm = "selection-of-material"
export const declarationDetailsForm = "declaration-details"

export const getMaterialDetailsUrl = (contractNumber: string, id: string) =>
	`${materials}/${contractNumber}/${id}`
export const getSelectionOfDeclarationTypeFormUrl = () =>
	`${materials}/${declarationCreation}/${selectionOfDeclarationTypeForm}`
export const getSelectionOfMaterialFormUrl = () =>
	`${materials}/${declarationCreation}/${selectionOfMaterialForm}`
export const getDeclarationDetailsFormUrl = () =>
	`${materials}/${declarationCreation}/${declarationDetailsForm}`
export const getSelectionOfDeclarationTypeFormWithMaterialUrl = (
	contractNumber: string,
	id: string,
) =>
	`${getMaterialDetailsUrl(contractNumber, id)}/${declarationCreation}/${selectionOfDeclarationTypeForm}`
export const getSelectionOfMaterialFormWithMaterialUrl = (
	contractNumber: string,
	id: string,
) =>
	`${getMaterialDetailsUrl(contractNumber, id)}/${declarationCreation}/${selectionOfMaterialForm}`
export const getDeclarationDetailsFormWithMaterialUrl = (
	contractNumber: string,
	id: string,
) =>
	`${getMaterialDetailsUrl(contractNumber, id)}/${declarationCreation}/${declarationDetailsForm}`
